<script>
import Layout from '@layouts/main.vue'
import Footer from '@components/footer.vue'
import ApplinkPopup from '@components/applink-popup.vue'
import SelectBarcodePopup from '@components/select-barcode-popup.vue'
import BarcodePopup from '@components/barcode-popup.vue'
import FacilityPopup from '@components/popup-no-facility-detail.vue'
import Tel from '@components/common/tel.vue'
import shopNone from '@img/map/noimage.png'
import popupPreview from '@utils/popup-preview.js'
import { getClientType } from '@utils/client'
import * as Swiper from '@/node_modules/swiper/swiper-bundle.min.js'
import {
  setSessionItem,
  removeSessionItem,
  clearSessionSearch,
} from '@utils/session.js'
import {
  toSearchResultWithQuery,
  toNewEndWithQuery,
  toSearchTagFacilityWithQuery,
  toBrandFacilityWithQuery,
  toMapWithQuery,
} from '@state/modules/facility-search.js'
import popup from '@utils/popup.js'
import { mapState } from 'vuex'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { template } from '@babel/core'

export const DISPLAYMODE = {
  START: 0,
  START_OPEN: 1,
  CONDITION: 2,
}
export default {
  name: 'FacilityDetail',
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { name: 'description', content: this.metaDescription },
        { name: 'keywords', content: this.metaKeyword },
        { property: 'og:description', content: this.metaDescription },
        { property: 'og:title', content: this.metaTitle },
        { property: 'og:type', content: 'article' },
        { property: 'og:site_name', content: 'JAFナビ' },
        { property: 'og:image', content: this.metaPhotoUrl },
        { property: 'og:url', content: this.metaUrl },
      ],
    }
  },
  components: { Layout, ApplinkPopup, SelectBarcodePopup, BarcodePopup,  FacilityPopup,Loading, Footer, Tel },
  data() {
    return {
      showApplink: false,
      showSelectBarcode: false,
      showBarcode: false,
      showFacilityPop: false,
      barcodePopupData: {},
      swiper: null,
      galleryTop: null,
      counter: 0,
      SHOP_TAB: 1,
      COUPON_TAB: 2,
      tabActive: 1,
      isCouponLoading: false,
      isBack: false,
      couponModalWindowFlg: false,
      groupModalWindowFlg: false, // coupon list popup
      showAccordion: false, // coupon list accordion
      txtBarcodeBtn: "",
      txtBarcodeSubBtn: "",
      isSentGA: false,
      jafDomains: this.$store.state.domains.jafDomains,
    }
  },
  computed: {
    ...mapState({
      facilityData: (state) =>
        state.facilities.shop ? state.facilities.shop : {},
        barcodeData: (state) =>
        state.facilities.shop.barcode ? state.facilities.shop.barcode : {},
      favorFlag: (state) => state.facilities.isClipped,
      coupons: (state) => state.facilities.coupons,
      host: (state) => state.env.href,
      scrollToTop: (state) => state.coupons.scrollToTop,
    }),
    title() {
      if(this.facilityData.MEISYO) {
        return `${this.facilityData.MEISYO} | JAFナビ`
      } else {
        return ` | JAFナビ`
      }
    },
    metaTitle() {
      return this.facilityData.MEISYO
    },
    metaDescription() {
      return this.facilityData.KAISETU
    },
    metaKeyword() {
      if (this.facilityData.KENSAKU_KWD) {
        var str = this.facilityData.KENSAKU_KWD

        var result = str.replace(/\s+/g, ',')
        return result
      } else {
        return ''
      }
    },
    metaUrl() {
      return location.href
    },
    metaPhotoUrl() {
      if (this.facilityData.PHOTO1) {
        var url = this.facilityData.PHOTO1
        return url
          ? this.$store.getters['env/apiBase'] +
              '/images/ph' +
              (Array(9 - url.length).join('0') + url).substring(
                -9 + url.length
              ) +
              '.jpg'
          : ''
      } else {
        return ''
      }
    },
    infoTagHeaderCSS() {
      if (!this.isLinksMode) {
        return [this.$style.infoTag,this.$style.header_banner];
      } else {
        return [this.$style.infoTag,this.$style.header_banner,this.$style.header_banner_none_header];
      }
    },
    headBannerDivCSS() {
      if (!this.isLinksMode) {
        return this.$style.head_banner_div;
      } else {
        return [this.$style.head_banner_div,this.$style.head_banner_div_none_header];
      }
    },
    barcodeButtonCSS() {
      if (this.txtBarcodeBtn.length > 0 || this.txtBarcodeSubBtn.length > 0 ) {
        return [this.$style.button, this.$style.barcode_button];
      } else {
        return this.$style.button;
      }
    },
    barcodeButtonCSS2() {
      if (this.txtBarcodeBtn.length > 0 && this.txtBarcodeSubBtn.length > 0 ) {
        return this.$style.barcodeBtn;
      } else {
        return [this.$style.barcodeBtn, this.$style.barcodeHgt];
      }
    },
    facilityInfoBoxCSS() {
      if (!this.isLinksMode) {
        return this.$style.facility_info_box;
      } else {
        return [this.$style.facility_info_box, this.$style.facility_info_box_isLkmd];
      }
    },
    favorCSS() {
      // お気に入り時は「on」
      return this.favorFlag === '1'
        ? [this.$style.favorite, this.$style.on]
        : this.$style.favorite
    },
    photoUrl1() {
      if (this.facilityData.PHOTO1) {
        var url1 =
          'background-image:url("' +
          this.$store.getters['env/apiBase'] +
          '/images/ph' +
          (
            Array(9 - this.facilityData.PHOTO1.length).join('0') +
            this.facilityData.PHOTO1
          ).substring(-9 + this.facilityData.PHOTO1.length) +
          '.jpg")'
        return url1
      } else {
        return ''
      }
    },
    photoUrlCap1() {
      if (this.facilityData.PHOTO1_CAP) {
        return this.facilityData.PHOTO1_CAP
      } else {
        return this.facilityData.MEISYO + '-1枚目'
      }
    },
    photoUrl2() {
      if (this.facilityData.PHOTO2) {
        var url2 =
          'background-image:url("' +
          this.$store.getters['env/apiBase'] +
          '/images/ph' +
          (
            Array(9 - this.facilityData.PHOTO2.length).join('0') +
            this.facilityData.PHOTO2
          ).substring(-9 + this.facilityData.PHOTO2.length) +
          '.jpg")'
        return url2
      } else {
        return ''
      }
    },
    photoUrlCap2() {
      if (this.facilityData.PHOTO2_CAP) {
        return this.facilityData.PHOTO2_CAP
      } else {
        return this.facilityData.MEISYO + '-2枚目'
      }
    },
    defaultAvatar() {
      return 'this.src ="' + shopNone + '"'
    },
    noImage() {
      return shopNone
    },
    discount1() {
      const _this = this
      var GAKURITU = this.facilityData.WB_GAKURITU1
      if (_this.facilityData.WB_NAIYO1) {
        for (let i = 0; i < Object.keys(this.facilityData).length; i++) {
          var gakuritsu = '' + _this.facilityData.WB_GAKURITU1
          if (this.facilityData.WB_TANIKU1 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU1 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU1 + '割引'
              }
            }
          }
          if (this.facilityData.WB_TANIKU1 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU1 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU1 + '引'
              }
            }
          }
        }
      }
      return GAKURITU
    },
    discount2() {
      const _this = this
      var GAKURITU = this.facilityData.WB_GAKURITU2
      if (_this.facilityData.WB_NAIYO2) {
        for (let i = 0; i < Object.keys(this.facilityData).length; i++) {
          var gakuritsu = '' + _this.facilityData.WB_GAKURITU2
          if (this.facilityData.WB_TANIKU2 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU2 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU2 + '割引'
              }
            }
          }
          if (this.facilityData.WB_TANIKU2 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU2 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU2 + '引'
              }
            }
          }
        }
      }
      return GAKURITU
    },
    discount3() {
      const _this = this
      var GAKURITU = this.facilityData.WB_GAKURITU3
      if (_this.facilityData.WB_NAIYO3) {
        for (let i = 0; i < Object.keys(this.facilityData).length; i++) {
          var gakuritsu = '' + _this.facilityData.WB_GAKURITU3
          if (this.facilityData.WB_TANIKU3 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU3 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU3 + '割引'
              }
            }
          }
          if (this.facilityData.WB_TANIKU3 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU3 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU3 + '引'
              }
            }
          }
        }
      }
      return GAKURITU
    },
    discount4() {
      const _this = this
      var GAKURITU = this.facilityData.WB_GAKURITU4
      if (_this.facilityData.WB_NAIYO4) {
        for (let i = 0; i < Object.keys(this.facilityData).length; i++) {
          var gakuritsu = '' + _this.facilityData.WB_GAKURITU4
          if (this.facilityData.WB_TANIKU4 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU4 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU4 + '割引'
              }
            }
          }
          if (this.facilityData.WB_TANIKU4 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU4 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU4 + '引'
              }
            }
          }
        }
      }
      return GAKURITU
    },
    discount5() {
      const _this = this
      var GAKURITU = this.facilityData.WB_GAKURITU5
      if (_this.facilityData.WB_NAIYO5) {
        for (let i = 0; i < Object.keys(this.facilityData).length; i++) {
          var gakuritsu = '' + _this.facilityData.WB_GAKURITU5
          if (this.facilityData.WB_TANIKU5 === '1') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*%.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU5 + '％割引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU5 + '割引'
              }
            }
          }
          if (this.facilityData.WB_TANIKU5 === '2') {
            // 割引単位区分が1(％)だった場合
            if (!gakuritsu.match('/.*引.*/')) {
              // 割引額に「引」が含まれていない場合
              if (!gakuritsu.match('/.*円.*/')) {
                // 割引額に「％」が含まれていない場合
                // 割引額に「％割引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU5 + '円引'
              } else {
                // 割引額に「％」が含まれていた場合
                // 割引額に「引」を付与
                GAKURITU = this.facilityData.WB_GAKURITU5 + '引'
              }
            }
          }
        }
      }
      return GAKURITU
    },
    getKaisetsu() {
      var TempKaisetu = this.facilityData.KAISETU
      if (this.facilityData.KAISETU) {
        TempKaisetu = TempKaisetu.replace(/(\\r)*\\n/g, '<br>')
      }
      return TempKaisetu
    },
    getBikou() {
      var TempBikou = this.facilityData.BIKOU
      if (this.facilityData.BIKOU) {
        TempBikou = TempBikou.replace(/(\\r)*\\n/g, '<br>')
      }
      return TempBikou
    },
    getCyuui() {
      var TempCyuui = this.facilityData.WB_CYUUI
      if (this.facilityData.WB_CYUUI) {
        TempCyuui = TempCyuui.replace(/(\\r)*\\n/g, '<br>')
      }
      return TempCyuui
    },
    // 特別優待エリア表示有無の判定(期間日付より、期間時刻よりではない)
    isShowTokubetsuValidityDatePeriodArea() {
      if (this.facilityData.TOKUBETU_FLAG !== '1') {
        return false
      }

      if (!this.facilityData.TOKUBETUURL) {
        return false
      }

      if (
        this.facilityData.KOUKAIKAISI &&
        moment() < moment(this.facilityData.KOUKAIKAISI)
      ) {
        return false
      }

      if (
        this.facilityData.KOUKAISYURYO &&
        moment() > moment(this.facilityData.KOUKAISYURYO).endOf('day')
      ) {
        return false
      }
      if (this.isLinksMode) {
        return false
      }

      return true
    },
    isLinksMode() {
      if (
        this.$store.state.auth.userType == '80' &&
        this.$store.state.auth.loggedIn
      ) {
        return true
      }

      return false;
    },
    linksAddClass() {
      if(this.isLinksMode)
      {
        return 'none_header'
      }
      else {
        return ''
      }
    },
    clientType() {
      return getClientType()
    },
    checkTokubetsuPeriod() {
      var kaisijikann  = "" ;
      if(this.facilityData.KOUKAIKAISI){
        kaisijikann = this.facilityData.KOUKAIKAISI;
      } else {
        // 日付設定してない時
        kaisijikann = "19000101";
      }

      if(this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU) {
        kaisijikann += this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU;
      } else {
        // 時間設定してない時
        kaisijikann += "000000";
      }

      var syuryojikann = "" ;
      if(this.facilityData.KOUKAISYURYO){
        syuryojikann = this.facilityData.KOUKAISYURYO;
      } else {
        // 日付設定してない時
        syuryojikann = "22001231";
      }

      if(this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU) {
        syuryojikann += this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU;
      }else {
        // 時間設定してない時
        syuryojikann += "250000";
      }

      var genzaijikan = moment().format('YYYYMMDDHHmmss')

      if (genzaijikan >= kaisijikann && genzaijikan < syuryojikann){
        // 期間内
        return '1';
      }else {
        // 期間外
        return '0';
      }
    },
    isExcludeWebFacilities() {
      let facilities_id_list = [];
      if (process.env.NODE_ENV === 'production') {
          facilities_id_list  = ['131113X09541','271113X03501','271127X03633'];
      }else{
          facilities_id_list  = ['271113X02644','001327X00443'];
      }
      return facilities_id_list.includes(this.facilityData.SHISETU_ID);
    },


    // getPrefecture() {
    //   // 都道府県名を取得する
    //   const _this = this
    //   if (_this.facilityData.TODOUFUKEN) {
    //     const prefture = _this.$store.state.area.couponPrefectureList.filter(
    //       (item) => {
    //         return item.prefecture_code === _this.facilityData.TODOUFUKEN
    //       }
    //     )
    //     return prefture[0].option_list
    //   }
    //   return ''
    // },
  },
  watch: {
    facilityData(newValue, oldValue) {
      setTimeout(() => {
        if (
          this.facilityData.COUPON_TARGET_FLAG === '1' &&
          this.$store.state.auth.loggedIn
        ) {
          this.tabActive = 2
          this.changeTab(2)
        } else {
          this.tabActive = 1
        }
        this.$store.dispatch('layout/endLoading')
        if (
          this.facilityData.MENBER_ONLY_FLAG === '1' &&
          !this.$store.state.auth.loggedIn
        ) {
          this.$popup({
            text: 'この施設の詳細を表示するにはログインを行ってください。',
            url: '/',
            loginurl: this.facilityUrl(this.$route.params.id),
            noCloseFlag: '1',
          })
        }
        if
          ((
          this.facilityData.FACILITIES_TYPE ==="" || this.facilityData.FACILITIES_TYPE ===null) ||
          (this.facilityData.FACILITIES_TYPE &&
          !(this.facilityData.FACILITIES_TYPE ==='1'||
          this.facilityData.FACILITIES_TYPE ==='3'||
          this.facilityData.FACILITIES_TYPE ==='5')))
        {
        this.$store.dispatch('facilities/updateShop', '')
        this.showFacilityPop = true
        this.$store.dispatch('layout/hideTabbar')
        }
      }, 100)
      this.$nextTick(() => {
        // 生成済みのインスタンスを破棄
        if (this.galleryTop) {
            this.galleryTop.destroy();
        }
        if (this.photoUrl1 && this.photoUrl2) {
          this.initSwiperGallery()
        }
        this.barcodeButtonText()
        this.barcodeButtonSubText()
      })
    },
    coupons(newValue, oldValue) {
      this.isCouponLoading = false
    },
    $route(to, from) {
      this.isBack =
        to.name === 'facility-detail' && from.name === 'coupon-detail'
    },
  },
  mounted() {
    // TODO: customer_id : localStorage.getItem('customerID')
  },
  deactivated() {
    if (this.galleryTop) {
      if (this.galleryTop.activeIndex === 1) {
        this.counter = 1
      } else {
        this.counter = 0
      }
    }
    this.$store.dispatch('facilities/updateShop', '')
    this.isSentGA = false
  },
  async activated() {
    // ここから、施設詳細ページ本来の初期表示処理（データを取得して画面を表示）
    if(!this.isSentGA)
    {
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_施設詳細',
      })
      this.isSentGA = true
    }
    this.$store.dispatch('layout/disableFocusHide')
    this.$store.dispatch('layout/startLoading')
    if (this.facilityData.FACILITIES_ID !== this.$route.params.id) {
      // TODO: clear shop data
    }
    // 生成済みのインスタンスを破棄
    if (this.galleryTop) {
        this.galleryTop.destroy();
    }
    if (this.photoUrl1 && this.photoUrl2) {
      this.initSwiperGallery()
    }
    this.getFacilityData()
    if (this.isBack) {
      const scrollEl = document.getElementById('jaf_container')
      scrollEl.scrollTop = this.$route.meta.containerScrollTop
    }
    this.getCouponData(); // クーポンある、ログインした場合、データ取得
    sessionStorage.removeItem('DETAIL_LAT')
    sessionStorage.removeItem('DETAIL_LON')

    //ここから、未ログインでアプリクーポン、プレミアム優待をクリック→ログイン画面でログイン→施設詳細に遷移した際の処理
    const nextUrl = new URLSearchParams(location.search).get("nextUrl");
    if(this.$store.state.auth.loggedIn){
      // nextTransitionTypeが、1(アプリクーポンのページへ遷移)、2(プレミアム優待のページへ遷移)
      var nextTransitionType = '';
      if(nextUrl && nextUrl.includes('coupon/coupon.html?coupon_no=')){
        nextTransitionType = '1';
        // 遷移後のブルウザバック時のことを考慮して、nexturlパラメータがついている施設詳細の履歴を書き換えて、nexturlがついていないURLにする。
        history.replaceState(null, '', this.$route.params.id);
      }else if(nextUrl && nextUrl.includes('web/facility_prem.php')){
        nextTransitionType = '2';
        // 遷移後のブルウザバック時のことを考慮して、nexturlパラメータがついている施設詳細の履歴を書き換えて、nexturlがついていないURLにする。
        history.replaceState(null, '', this.$route.params.id);
      }

      if(nextTransitionType==='1'){
          window.dataLayer.push({
            event: 'JAFナビ_施設詳細_クーポン枠押下',
            ap_screen_name: 'JAFナビ_施設詳細_アプリクーポン表示',
          })
          location.href = nextUrl;
      }else if(nextTransitionType==='2'){
        // form
        var parent = document.getElementById('ssnIdPremPostForm');
        document.ssnIdFormPrem.action=nextUrl;
        // 施設ID　
        var input_facility_id = document.getElementById('sisetuInput');
        if(!input_facility_id){
          input_facility_id = document.createElement('input');
          input_facility_id.type = 'hidden';
          input_facility_id.name = 'sisetu_id';
          input_facility_id.id = 'sisetuInput';
        }
        input_facility_id.value = this.$route.params.id;
        parent.appendChild(input_facility_id);
        // exec_mode
        var input_exec_mode = document.getElementById('execModeInput');
        if(!input_exec_mode){
          input_exec_mode = document.createElement('input');
          input_exec_mode.type = 'hidden';
          input_exec_mode.name = 'exec_mode';
          input_exec_mode.id = 'execModeInput';
        }
        input_exec_mode.value = 1;
        parent.appendChild(input_exec_mode);
        // ssnId
        var input_ssnid = document.getElementById('ssnidPremInput');
        if(!input_ssnid){
          input_ssnid = document.createElement('input');
          input_ssnid.type = 'hidden';
          input_ssnid.name = 'SsnId';
          input_ssnid.id = 'ssnidPremInput';
        }
        input_ssnid.value = window.localStorage.getItem('SsnId');
        parent.appendChild(input_ssnid);
        // submit
        document.ssnIdFormPrem.submit();
      }
    }else if(nextUrl && (nextUrl.includes('coupon/coupon.html?coupon_no=') || nextUrl.includes('web/facility_prem.php')) ){
      // 遷移後のブルウザバック時のことを考慮して、nexturlパラメータがついている施設詳細の履歴を書き換えて、nexturlがついていないURLにする。
      history.replaceState(null, '', this.$route.params.id);
    }

  },
  methods: {
    loginUrl(couponNo) {
      let nextUrlPrm = '';
      if(this.clientType !== 2){
        if (process.env.NODE_ENV === 'production') {
            nextUrlPrm  = '?nextUrl=https://cdn.jafnavi.jp/coupon/coupon.html?coupon_no=' + couponNo;
        }else{
            nextUrlPrm  = '?nextUrl=https://jafapp-kensho.web.app/coupon/coupon.html?coupon_no=' + couponNo;
        }
      }
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
          process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(decodeURI('https://' + location.host + location.pathname + nextUrlPrm))}`
      return url
    },
    login(couponNo) {
      // this.$store.dispatch('auth/simpleLogin')
      event.preventDefault()
      location.href = this.loginUrl(couponNo)
    },
    clearToTop() {
      this.$store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
      clearSessionSearch()
      this.$router.push({
        name: 'facility-search',
        params: { clear: true },
      })
    },
    dateString(date){
      // 日付フォーマット変換、日本語曜日対応
      moment.locale('ja', {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
      });
      return moment(date).format('YYYY年MM月DD日（ddd）') ;
    },
    isMobile() {
      return window.innerWidth < 768
    },
    // モーダルが閉じられ時...
    groupModalClose(param) {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, this.windowScrollY)

      // モーダルを閉じる
      this.groupModalWindowFlg = false
    },
    // クーポンアコーディオン閉じる
    closeAccordion(){
      document.getElementsByClassName('accordion_show')[0].style.maxHeight = '86px'
      this.showAccordion = false
      window.scrollTo(0, this.windowScrollY)

    },
    // クーポンリスト表示
    showCoupons(show){
      if(this.isMobile()){
        window.dataLayer.push({
          event: 'クーポン選択押下',
          ap_screen_name: 'JAFナビ_施設詳細_アプリクーポン表示',
        })
        var couponHeight = '100vh';
        if (this.coupons && this.coupons.length > 4) {
          couponHeight = '' + 130 * this.coupons.length + 'vh';
        }
        document.getElementsByClassName('accordion_show')[0].style.maxHeight = couponHeight
        this.showAccordion = true
        this.windowScrollY = window.scrollY

      }else{
        // モーダルを開く
        this.groupModalWindowFlg = true

        // モーダルが開いたら、bodyにfixedを付与
        this.windowScrollY = window.scrollY
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'
        document.body.style.top = '-' + this.windowScrollY + 'px'
      }
    },
    sentPost(url){
      document.ssnIdForm.action = url;
      if(this.$store.state.auth.loggedIn){
        var input_data = document.getElementById("ssnidInput")
        if(!input_data){
          input_data = document.createElement('input');
          input_data.type = 'hidden';
          input_data.name = 'SsnId';
          input_data.id = 'ssnidInput';
          var parent = document.getElementById('ssnIdPostForm');
          parent.appendChild(input_data);
        }
        input_data.value = this.$store.state.auth.sessionId;
      }
      document.ssnIdForm.submit();
    },
    timeNumToString(timeSting){
      return timeSting.slice(0,2) + ":" + timeSting.slice(2,4);
    },
    barcodeButtonText(){
      this.txtBarcodeBtn = "";
      if(this.facilityData && this.facilityData.USED_BUTTON_TEXT){
        this.txtBarcodeBtn = this.facilityData.USED_BUTTON_TEXT;
      }else{
        this.txtBarcodeBtn = "この施設を利用する"
      }
    },
    barcodeButtonSubText(){
      this.txtBarcodeSubBtn = "";
      if(this.facilityData &&
        this.facilityData.USED_BUTTON_SUB_TEXT_USE &&
        this.facilityData.USED_BUTTON_SUB_TEXT_USE === '1'
      ){
        if(this.facilityData.USED_BUTTON_SUB_TEXT){
          this.txtBarcodeSubBtn = this.facilityData.USED_BUTTON_SUB_TEXT;
        }else{
          this.txtBarcodeSubBtn = "(バーコードを表示する)";
        }
      }
    },
    showBarcodeButton(){
      if(this.facilityData && this.facilityData.USED_TYPE){
        if(this.facilityData.USED_TYPE === '1'){
          return "code";
        }else{
          return "card";
        }
      }else{
          return "card";
      }
    },
    goGuidance(){
      window.open('https://area.jaf.or.jp/guidance/benefits-notes', '_blank')
    },
    initSwiperGallery() {
      // 生成済みのインスタンスを破棄
      if (this.galleryTop) {
          this.galleryTop.destroy();
      }
      this.galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        // thumbs: {
        //   swiper: this.swiper,
        // },
        pagination: {
          el: '.detail-swiper-pagination',
        },
        loop: true, // ループ有効
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
      })
      // 112233
      this.galleryTop.addItem = 'esLint'
      this.galleryTop.update()
      var that = this
      this.galleryTop.on('touchEnd', function () {
        if (that.counter === 1) {
          if (that.galleryTop.activeIndex === 0) {
            that.galleryTop.slideTo(1)
          }
        }
      })
    },
    // 優待施設詳細データ取得
    getFacilityData() {
      var payload = {}
      payload.FACILITIES_ID = this.$route.params.id
      if (this.$store.state.coupons.preview !== '') {
        payload.PREVIEW = this.$store.state.coupons.preview
        payload.COUPON_NO = this.$store.state.coupons.coupon_no
      }
      this.$store.dispatch('facilities/updateShop', payload)
      .then(() => {
        if (
          !(this.$store.state.facilities.shop.hasOwnProperty("SHISETU_ID"))
           && !(this.$store.state.facilities.shop.hasOwnProperty("MENBER_ONLY_FLAG"))
         ) {
          // shopに施設IDが存在しない、且つ、JAF会員限定フラグが存在しない場合（shopが [] または false の状態） 404 へリダイレクト
          this.$router.push({
            name: '404'
          })
        }
      })
    },
    // デジタル会員証(SU-11)画面へ連携する
    toMemberCard() {
      if (this.$store.state.coupons.preview !== '') {
        popupPreview()
      } else {
        // 会員種別が「車両会員」または「車両会員（レンタカー）」の場合ポップアップを表示する
        if (
          localStorage.getItem('userType') === '"4"' ||
          localStorage.getItem('userType') === '"3"'
        ) {
          this.$popup({
            text: 'ご確認ください。 <br/> 法人会員でログインした場合、デジタル会員証はご利用いただけません。JAFの諸サービスをご利用の際には会員証をご用意ください。',
          })
        } else {
          const _this = this
          window.dataLayer.push({
            event: 'JAFナビ_施設詳細_デジタル会員証表示押下',
            ap_screen_name: 'JAFナビ_施設詳細_JAFアプリ（会員証）表示',
          })

          if (process.env.NODE_ENV === 'production') {
            window.open('https://cdn.jafnavi.jp/top/index.html', '_blank')
          } else {
            // window.location.href = 'https://jafapp-kensho.web.app/top.html'
            window.open(
              'https://jafapp-kensho.web.app/top/index.html',
              '_blank'
            )
          }
        }
      }
    },
    // 電話番号を電話アプリで起動する
    toTelPhone() {
      const _this = this
      window.dataLayer.push({
        event: '電話番号押下　外部サイトへの遷移',
        event_action: this.facilityData.TEL,
        event_category: '外部サイト遷移',
        ap_screen_name: '優待_施設詳細　電話番号',

        ap_member_id: _this.$store.state.auth.memberNo,
        ap_member_type: localStorage.getItem('userType'),
      })
      // #3290
      // 第一段階（3月末）のリリースでは、「TEL」のリンクは無効であり、青字で表示されないこと。
      // uncomment this in next relese after march 2020
      // window.location.href = 'applink://tel?number=' + this.facilityData.TEL
    },
    // 施設住所表示（SU-06-02）画面へ遷移する
    toMap() {
      sessionStorage.setItem('DETAIL_LAT', this.facilityData.LAT)
      sessionStorage.setItem('DETAIL_LON', this.facilityData.LON)
      sessionStorage.setItem('MEISYO', this.facilityData.MEISYO)
      this.$router.push({ name: 'facility-map' })
    },
    // パソコン用ホームページを外部ブラウザで起動する
    toPCUrl() {
      window.dataLayer.push({
        event: 'JAFナビ_施設詳細URLリンク押下',
        ap_screen_name: 'JAFナビ_施設詳細URLリンク押下表示',
      })
      if (this.$store.state.coupons.preview !== '') {
        window.open(this.facilityData.PC_URL, '_blank') // ←★ここ
      } else {
        window.open(this.facilityData.PC_URL, '_blank')
      }
    },
    // パソコン用ホームページを外部ブラウザで起動する
    toOnlineUrl() {
      if (!this.$store.state.auth.loggedIn) {
        this.$popup({
          text: '本機能を利用するにはログインを行ってください。',
          url: '/',
          loginurl: this.facilityUrl(this.$route.params.id),
        })
      } else {
        const pcUrl = this.facilityData.PC_URL
        const domain = pcUrl.match(/^https?:\/{2,}(.*?)(?:\/|\?|#|$)/)[1]
        if (
          domain === 'jafnavi.jp' ||
          domain === 'www.jaf.or.jp' ||
          domain === 'area.jaf.or.jp'
        ) {
          window.dataLayer.push({
            event: 'オンライン優待を見るボタン押下',
            ap_screen_name: 'JAFナビ_オンライン優待を見る表示',
          })
          this.sentPost(pcUrl)
        } else {
          window.open(pcUrl, '_blank');
        }
      }
    },
    // 特別優待URLを外部ブラウザで起動する
    toTokubetsuUrl() {
      if (this.$store.state.coupons.preview !== '') {
        popupPreview()
      } else {
        var genzaijikan = moment().format('YYYYMMDDHHmmss')
        // 時間設定してない時
        if(!this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU){
          this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU = "000000"
        }
        if(!this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU){
          this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU = "250000"
        }
        var kaisijikann = this.facilityData.KOUKAIKAISI+this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU
        var syuryojikann = this.facilityData.KOUKAISYURYO+this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU
        let popupText = "この施設の特別優待は<br/>";

        // 現在時刻が「特別優待」開始日時よりも前の場合
        if(kaisijikann){
          if(genzaijikan < kaisijikann){
              const startTime = this.timeNumToString(this.facilityData.TOKUBETUKOUKAIKAISIJIKOKU)
              const startTimeString =  moment(this.facilityData.KOUKAIKAISI).format('MM月DD日') + " " +  startTime;
              popupText = popupText + startTimeString + 'から開始します。<br/><br/>いつでも使える通年優待をご利用ください。';
              this.$popup({
                text: popupText,
              })
              return;
            }
          }

        // 現在時刻が「特別優待」終了日時よりも後の場合
        if(syuryojikann){
          if(genzaijikan > syuryojikann){
            const endTime = this.timeNumToString(this.facilityData.TOKUBETUKOUKAISYURYOJIKOKU)
            const endTimeString =  moment(this.facilityData.KOUKAISYURYO).format('MM月DD日') + " " +  endTime;
            popupText = popupText + endTimeString + 'で終了しました。<br/><br/>いつでも使える通年優待をご利用ください。';
             this.$popup({
              text: popupText,
            })
            return;
          }
        }
        window.dataLayer.push({
          event: 'JAFナビ_施設詳細_特別優待枠押下',
          ap_screen_name: 'JAFナビ_施設詳細_特別優待枠押下',
        })
        this.sentPost(this.facilityData.TOKUBETUURL)
      }
    },
    // 特別優待URLを外部ブラウザで起動する
    toPremiamUrl() {
      if (this.$store.state.coupons.preview !== '') {
        popupPreview()
      } else {
        window.dataLayer.push({
          event: 'プレミアム優待を見るボタン押下',
          ap_screen_name: 'JAFナビ_プレミアム優待を見る表示',
        })
        // const host =
        //   process.env.NODE_ENV === 'production'
        //     ? link.JAF_NAVI_TOP
        //     : link.JAF_NAVI_TOP_TEST
        // const ssnId = window.localStorage.getItem('SsnId')
        // const url =
        //   process.env.VUE_APP_MODE !== 'production'
        //     ? `https://test.jafnavi.jp/web/facility_prem.php?sisetu_id=${this.facilityData.SHISETU_ID}&exec_mode=1&SsnId=${ssnId}`
        //     : `https://jafnavi.jp/web/facility_prem.php?sisetu_id=${this.facilityData.SHISETU_ID}&exec_mode=1&SsnId=${ssnId}`
        // window.open(url, '_blank')

        if(this.$store.state.auth.loggedIn){
          // form
          var parent = document.getElementById('ssnIdPremPostForm');
          // form action url
          document.ssnIdFormPrem.action=
          process.env.VUE_APP_MODE !== 'production'
            ? `https://test.jafnavi.jp/web/facility_prem.php`
            : `https://jafnavi.jp/web/facility_prem.php`
          // 施設ID　
          var input_facility_id = document.getElementById('sisetuInput');
          if(!input_facility_id){
            input_facility_id = document.createElement('input');
            input_facility_id.type = 'hidden';
            input_facility_id.name = 'sisetu_id';
            input_facility_id.id = 'sisetuInput';
          }
          input_facility_id.value = this.facilityData.SHISETU_ID;
          parent.appendChild(input_facility_id);
          // exec_mode
          var input_exec_mode = document.getElementById('execModeInput');
          if(!input_exec_mode){
            input_exec_mode = document.createElement('input');
            input_exec_mode.type = 'hidden';
            input_exec_mode.name = 'exec_mode';
            input_exec_mode.id = 'execModeInput';
          }
          input_exec_mode.value = 1;
          parent.appendChild(input_exec_mode);
          // ssnId
          var input_ssnid = document.getElementById('ssnidPremInput');
          if(!input_ssnid){
            input_ssnid = document.createElement('input');
            input_ssnid.type = 'hidden';
            input_ssnid.name = 'SsnId';
            input_ssnid.id = 'ssnidPremInput';
          }
          input_ssnid.value = window.localStorage.getItem('SsnId');
          parent.appendChild(input_ssnid);
          // submit
          document.ssnIdFormPrem.submit();
        }else{
          this.$popup({
            text: '本機能を利用するにはログインを行ってください。',
            url: '/',
            loginurl: this.facilityUrl(this.$route.params.id,'toPremiamUrl'),
          })
        }
      }
    },
    backHandler() {
      // 「アプリクーポン」が複数あるとき、初期表示時にアコーディオンが閉じる状態になるため
      this.showAccordion = false;
      this.groupModalWindowFlg = false;
      // TODO: 戻るフラグチェック
      if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-05') {
        toSearchResultWithQuery()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-01') {
        this.clearToTop()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-03') {
        toMapWithQuery()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-07-01') {
        toNewEndWithQuery()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-07-02') {
        toBrandFacilityWithQuery()
      } else if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-07-03') {
        toSearchTagFacilityWithQuery()
      } else {
        this.$route.meta.isBackToCoupon = true
        this.$router.go(-1)
      }
    },
    openApplink() {
      if (this.$store.state.coupons.preview !== '') {
        popupPreview()
      } else {
        // TODO: customer_id : localStorage.getItem('customerID')
        window.dataLayer.push({
          event: '道案内・カーナビ連携押下',
          ap_screen_name: 'JAFナビ_案内手段選択',
        })
        sessionStorage.setItem('DETAIL_LAT', this.facilityData.LAT)
        sessionStorage.setItem('DETAIL_LON', this.facilityData.LON)
        this.showApplink = true
        this.$store.dispatch('layout/hideTabbar')
      }
    },
    cancelApplink() {
      this.showApplink = false
      this.$store.dispatch('layout/showTabbar')
    },
    openSelectBarcode() {
      if (!this.$store.state.auth.loggedIn) {
        this.$popup({
          text: '本機能を利用するにはログインを行ってください。',
          url: '/',
          loginurl: this.facilityUrl(this.$route.params.id),
        })
      } else {
        //ポップアップの最大数を拡張（広域ページ移行STEP2）
        //ポップアップがすべて掲載期間外の場合、メッセージを表示
        if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
        && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
          this.$popup({
            text: '現在、利用可能なバーコードはありません。',
          })
        }else{
          //単一のポップアップのみが掲載期間内の場合、ポップアップ選択画面をスキップして、バーコード情報を表示
          if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(1)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(2)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(3)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(4)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(5)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '0')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '1')){
            this.openBarcode(6)
          }else if((this.compare_date(this.barcodeData[0].PUBLICATION_START_DATE, this.barcodeData[0].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[1].PUBLICATION_START_DATE, this.barcodeData[1].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[2].PUBLICATION_START_DATE, this.barcodeData[2].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[3].PUBLICATION_START_DATE, this.barcodeData[3].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[4].PUBLICATION_START_DATE, this.barcodeData[4].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[5].PUBLICATION_START_DATE, this.barcodeData[5].PUBLICATION_END_DATE) === '1')
          && (this.compare_date(this.barcodeData[6].PUBLICATION_START_DATE, this.barcodeData[6].PUBLICATION_END_DATE) === '0')){
            this.openBarcode(7)
          }else{
            // ポップアップが2つ以上有効な場合、ポップアップ選択画面を表示
            // 非表示にしていたポップアップ選択画面を表示
            this.showSelectBarcode = true
            this.$store.dispatch('layout/hideTabbar')
            this.lock()
          }
        }
      }
    },
    cancelSelectBarcode() {
      this.unLock() // 広域ページ移行（STEP2）対応に伴い、ポップアップ選択画面において「✕」ボタンを押下した際、施設詳細画面のスクロールバーが消失しないよう変更。
      this.showSelectBarcode = false
      this.$store.dispatch('layout/showTabbar')
    },
    openBarcode(flag) {
      if (!this.$store.state.auth.loggedIn) {
        this.$popup({
          text: '本機能を利用するにはログインを行ってください。',
          url: '/',
          loginurl: this.facilityUrl(this.$route.params.id),
        })
      } else {
        //ポップアップの最大数を拡張（広域ページ移行STEP2）
        if (flag == '1') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示1',
              event_action:
                '1_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示1',
            })
          this.barcodePopupData = this.barcodeData[0];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '2') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示2',
              event_action:
                '2_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示2',
            })
          this.barcodePopupData = this.barcodeData[1];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '3') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示3',
              event_action:
                '3_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示3',
            })
          this.barcodePopupData = this.barcodeData[2];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '4') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示4',
              event_action:
                '4_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示4',
            })
          this.barcodePopupData = this.barcodeData[3];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '5') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示5',
              event_action:
                '5_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示5',
            })
          this.barcodePopupData = this.barcodeData[4];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '6') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示6',
              event_action:
                '6_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示6',
            })
          this.barcodePopupData = this.barcodeData[5];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }else if (flag == '7') {
          window.dataLayer.push({
              event: '施設詳細　ポップアップ表示7',
              event_action:
                '7_' + this.facilityData.SHISETU_ID + '_' + this.facilityData.MEISYO,
              event_category: '施設詳細　ポップアップ表示7',
            })
          this.barcodePopupData = this.barcodeData[6];
          this.barcodePopupData.SsnId = this.facilityData.CRYPT_SESSION_ID;
        }

        this.showSelectBarcode = false
        this.showBarcode = true
        this.$store.dispatch('layout/hideTabbar')
        this.lock()
      }
    },
    cancelBarcode() {
      this.unLock()
      this.barcodePopupData = {}
      this.showBarcode = false
      this.$store.dispatch('layout/showTabbar')
    },
    okPop() {
      this.showFacilityPop = false
      this.$store.dispatch('layout/showTabbar')
      this.backHandler()
    },
    // クーポンデータ取得
    async getCouponData(){
      this.isCouponLoading = true
      try {
        await this.$store.dispatch(
          'facilities/fetchCoupons',
          this.$route.params.id
        )
      } catch (e) {
        this.isCouponLoading = false
      }
    },
    async changeTab(i) {
      if (i === 2) {
        if (!this.facilityData.COUPON || this.facilityData.COUPON != 1) {
          return
        }
        if (!this.$store.state.auth.loggedIn) {
          this.$popup({
            text: '本機能を利用するにはログインを行ってください。',
            url: '/',
            loginurl: this.facilityUrl(this.$route.params.id),
          })
          this.tabActive = 1
        } else {
          if (this.$store.state.coupons.preview !== '') {
            popupPreview()
            this.tabActive = 1
          } else {
              window.dataLayer.push({
                event: 'Webview',
                ap_screen_name: 'JAFナビ_施設詳細_クーポンタブ表示',
              })
              this.isCouponLoading = true
              try {
                await this.$store.dispatch(
                  'facilities/fetchCoupons',
                  this.$route.params.id
                )
              } catch (e) {
                this.isCouponLoading = false
              }
          }
        }
      } else if (i === 1) {
        // TODO: customer_id : localStorage.getItem('customerID')
        // window.dataLayer.push({
        //   event: 'Webview',
        //   ap_screen_name: 'お気に入り_クーポン',
        //   ap_member_id: this.$store.state.auth.memberNo,
        //   ap_member_type: localStorage.getItem('userType'),
        // })
      }
      this.tabActive = i
    },
    clickCoupon(couponNo,couponUsed) {
      if(couponUsed == 1){
        return;
      }
      if (this.isLinksMode) {
        this.$popup({
          text: 'JAFLINKSからはご利用いただけません。',
        });
        return;
      }

      // 未ログインの場合
      if (!this.$store.state.auth.loggedIn) {
        // JAFログイン画面へ遷移
        this.login(couponNo);
      } else {
        window.dataLayer.push({
          event: 'JAFナビ_施設詳細_クーポン枠押下',
          ap_screen_name: 'JAFナビ_施設詳細_アプリクーポン表示',
        })
        if (this.clientType !== 2) {
          if (process.env.NODE_ENV === 'production') {
            location.href = 'https://cdn.jafnavi.jp/coupon/coupon.html?coupon_no=' + couponNo;
          } else {
            location.href = 'https://jafapp-kensho.web.app/coupon/coupon.html?coupon_no=' + couponNo;
          }
        } else {
          this.openCouponModal()
        }
      }
    },
    photoUrl(url) {
      return url
        ? this.$store.getters['env/apiBase'] +
            '/images/ph' +
            (Array(9 - url.length).join('0') + url).substring(-9 + url.length) +
            '.jpg'
        : noImg
    },
    stopEvent() {
      event.stopPropagation()
    },
    couponModalClose() {
      // モーダルが閉じられ時...
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, this.windowScrollY)
      // モーダルを閉じる
      this.couponModalWindowFlg = false
      // 全てのアコーディオン高さをリセット

      for (
        var i = 0;
        i < document.querySelectorAll('.type_multi .contents').length;
        i++
      ) {
        document.querySelectorAll('.type_multi .contents')[i].style.maxHeight =
          ''
      }
    },
    modalHeightSet() {
      // 画面高さ
      var wh = window.innerHeight
      var couponModalId = document.getElementById('coupon_popup')
      var headObj = couponModalId.getElementsByClassName('modal_head')
      var headH = headObj[0].offsetHeight
      var max = Math.floor(wh * 0.8 - headH)
      couponModalId.getElementsByClassName('modal_inner')[0].style.maxHeight =
        max - 20 + 'px'
    },
    openCouponModal() {
      window.dataLayer.push({
        event: 'アプリダウンロードモーダル表示',
        ap_screen_name: 'JAFナビ_施設詳細_アプリダウンロードメッセージ表示',
      })
      this.groupModalClose()
      // モーダルを開く
      this.couponModalWindowFlg = true

      // モーダルが開いたら、bodyにfixedを付与
      this.windowScrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = '-' + this.windowScrollY + 'px'
    },
    getNl2brString(str) {
      if (str) {
        str = str.replace(/(\\r)*\\n/g, '<br>')
      }
      return str
    },
    facilityUrl(shopId,purpose='') {
      let nextUrlPrm = '';
      if(purpose=='toPremiamUrl'){
        const action = process.env.VUE_APP_MODE !== 'production'
            ? `https://test.jafnavi.jp/web/facility_prem.php`
            : `https://jafnavi.jp/web/facility_prem.php`
        nextUrlPrm = '?nextUrl=' + action;
      }
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
          process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(
          decodeURI(`https://${location.host}/facility-detail/${shopId}${nextUrlPrm}`)
      )}`
      return url
    },
    lock() {
      document.documentElement.style.overflow = 'hidden'
      // document.documentElement.style.position = 'fixed'
      document.body.scroll = 'no'
    },
    unLock() {
      document.documentElement.style.overflow = 'scroll'
      // document.documentElement.style.position = 'relative'
      document.body.scroll = 'yes'
    },
    compare_date(dateStart, dateEnd) {
      if(!dateStart && !dateEnd){
        return '1'
      }
      var now_date   = moment();
      var date_start = moment(dateStart);
      var date_end   = moment(dateEnd);
      if (date_start > now_date || date_end < now_date){
        // 期間外
        return '1'
      }else {
        // 期間内
        return '0'
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.facilityDetail">
      <transition class="modal">
        <div
          v-if="couponModalWindowFlg"
          :id="$style.coupon_popup"
          @click="couponModalClose"
        >
          <div :class="$style.modal_set" @click="stopEvent">
            <div :class="$style.modal_contents">
              <div :class="$style.modal_head">
                <button :class="$style.modal_close" @click="couponModalClose"
                  ><img src="@img/icon_72_close.png"
                /></button>
              </div>
              <div :class="$style.modal_inner"
                >お使いの端末ではクーポンをご利用いただけません。<br />
                iPhone/Android端末にてJAFスマートフォンアプリをインストール後、ご利用ください。
                <a
                  href="https://cdn.jafnavi.jp/top/index.html?utm_source=app&utm_medium=linkbanner&utm_campaign=yutaijafnavi"
                  target="_blank"
                  >JAFスマートフォンアプリをダウンロード！（無料）</a
                >
                <div :class="$style.link_qr">
                  <img src="@img/QR/QR_02.png" :class="$style.qr" />
                </div>
                </div>
            </div>
          </div>
        </div>
      </transition>
      <transition class="modal">
        <div
          v-if="groupModalWindowFlg"
          :id="$style.group_popup"
          @click="groupModalClose"
        >
          <div :class="$style.modal_set" @click="stopEvent">
            <div :class="$style.modal_contents">
              <div :class="$style.modal_head">
                <div :class="$style.head_name">アプリクーポン</div>
                <button
                  :class="$style.modal_close"
                  @click="groupModalClose"
                >
                  <img src="@img/icon_72_close.png"/>
                </button>
              </div>

              <div :class="$style.modal_inner">
                <div
                  v-if="coupons && coupons[0]"
                  :class="$style.coupon_list"
                >
                  <div
                    v-for="(coupon, c_index) in coupons"
                    :key="c_index"
                    :class="$style.facility_content_box"
                    @click="clickCoupon(coupon.COUPON_NO,coupon.COUPON_USED_FLAG)"
                  >
                    <div :class="$style.img_icon_content_box">
                      <div :class="$style.icon_content_box">
                        <p :class="$style.icon_box">
                          <span :class="[$style.icon,$style.icon_app_coupon]">アプリクーポン</span>
                        </p>
                        <p
                          :class="[$style.content,$style.coupon_content]"
                          v-html="getNl2brString(coupon.COUPON_SUMMARY)"
                        ></p>
                      </div>
                    </div>
                    <div :class="$style.start_end_time">
                      {{dateString(coupon.COUPON_START_DATE)}} ～ {{dateString(coupon.COUPON_STOP_DATE)}}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div :class="infoTagHeaderCSS">
        <div v-if="!isLinksMode" :class="$style.header_box">
          <a :class="$style.backBtn" @click="backHandler">
            <span :class="$style.icon">
              <img src="@img/arrow_simple_32_L_navy.png" />
            </span>
            <span>戻る</span>
          </a>
          <div :class="$style.name">
            <h1>{{ facilityData ? facilityData.MEISYO : '' }}</h1>
          </div>
        </div>
        <div v-else :class="$style.header_box_linksmode">
          <a :class="$style.backBtn" @click="backHandler">
            <span :class="$style.icon">
              <img src="@img/arrow_simple_32_L_navy.png" />
            </span>
            <span>戻る</span>
          </a>
          <div :class="$style.name">
            <h1>{{ facilityData ? facilityData.MEISYO : '' }}</h1>
          </div>
        </div>
      </div>
      <div :class="headBannerDivCSS">
        <h1 :class="$style.banner_title">{{ facilityData ? facilityData.MEISYO : '' }}</h1>
      </div>
      <div
        :class="[
          $style.sp_visual,
          $style.mainVisual,
          photoUrl1 && photoUrl2 ? '' : $style.mainVisual_one,
          'photo_gallery',
        ]"
      >
        <div
          v-if="facilityData.PHOTO1 || facilityData.PHOTO2"
          :class="[
            'swiper-container',
            facilityData.PHOTO1 && facilityData.PHOTO2
              ? 'gallery-top'
              : 'one_image_box',
          ]"
        >
          <div class="swiper-wrapper">
            <!-- photo1  has_caption -->
            <div
              v-if="facilityData.PHOTO1 && facilityData.PHOTO1_CAP"
              class="swiper-slide has_caption"
            >
              <div class="caption_banner swiper_image_style" :style="photoUrl1"></div>
              <p>{{facilityData.PHOTO1_CAP}}</p>
            </div>
            <!-- photo1   no caption  -->
            <div
              v-else-if="facilityData.PHOTO1 && !facilityData.PHOTO1_CAP"
              class="swiper-slide swiper_image_style"
              :style="photoUrl1"
            ></div>
            <!-- photo2  has_caption -->
            <div
              v-if="facilityData.PHOTO2 && facilityData.PHOTO2_CAP"
              class="swiper-slide has_caption"
            >
              <div class="caption_banner swiper_image_style" :style="photoUrl2"></div>
              <p>{{facilityData.PHOTO2_CAP}}</p>
            </div>
            <!-- photo2   no caption  -->
            <div
              v-else-if="facilityData.PHOTO2 && !facilityData.PHOTO2_CAP"
              class="swiper-slide swiper_image_style"
              :style="photoUrl2"
            >
            </div>

          </div>
          <div class="detail-swiper-pagination"></div>
        </div>
        <div
          v-if="!(facilityData.PHOTO1 || facilityData.PHOTO2)"
          :class="$style.one_image_box"
        >
          <img :src="noImage" alt />
        </div>
      </div>
      <div :class="$style.contentLimit">
        <!-- images  -->
         <div>
          <div>
            <div :class="$style.pc_visual">
              <div :class="$style.main_visual">
                <div v-if="facilityData.PHOTO1" :class="$style.photo">
                  <img :src="photoUrl(facilityData.PHOTO1)" :alt="photoUrlCap1" />
                </div>
                <div v-if="facilityData.PHOTO2" :class="[$style.photo,$style.photo2_margin]">
                  <img :src="photoUrl(facilityData.PHOTO2)" :alt="photoUrlCap2" />
                </div>
                <div
                  v-if="!(facilityData.PHOTO1 || facilityData.PHOTO2)"
                  :class="$style.photo"
                >
                  <img :src="noImage" />
                </div>
              </div>
              <div :class="$style.main_visual">
                <div :class="$style.photo_cap">
                  <p v-if="facilityData.PHOTO1" :class="$style.photo_cap_txt">{{facilityData.PHOTO1_CAP}}</p>
                </div>
                <div v-if="facilityData.PHOTO2" :class="$style.photo_cap">
                  <p v-if="facilityData.PHOTO2" :class="$style.photo_cap_txt">{{facilityData.PHOTO2_CAP}}</p>
                </div>
              </div>
            </div>

            <div v-if="facilityData.PREMIAM_FLAG === '1' ||
                      (facilityData.COUPON && facilityData.COUPON === '1') ||
                      isShowTokubetsuValidityDatePeriodArea">
              <!-- 特別優待title -->
              <div :class="$style.limit_facility_box">
                <img src="@img/icon_calendar.png" alt="特別優待アイコン">
                <p :class="$style.facility_label">
                  特別優待
                </p>
              </div>
              <p :class="$style.facility_announce_label">
                詳細をご確認のうえご利用ください。<br />いつでも使える優待は、画面を下へスクロールしてご確認いただけます。
              </p>

              <div :class="$style.limited_facility_box">
                <!-- プレミアム優待 -->
                <div
                  v-if="!isLinksMode && facilityData.PREMIAM_FLAG === '1'"
                  :class="$style.facility_content_box"
                  @click="toPremiamUrl"
                >
                  <div :class="$style.img_icon_content_box">
                    <div :class="$style.icon_content_box">
                      <p :class="$style.icon_box">
                        <span :class="[$style.icon,$style.icon_premium]">プレミアム優待</span>
                      </p>
                      <p
                        :class="$style.content"
                        v-html="getNl2brString(facilityData.PREMIUM_DIST)"
                      ></p>
                    </div>
                  </div>
                  <div
                    v-if="facilityData.PREMIUM_START"
                    :class="$style.start_end_time"
                  >
                    {{dateString(facilityData.PREMIUM_START)}} ～ {{dateString(facilityData.PREMIUM_END)}}
                  </div>
                </div>

                <!-- クーポン -->
                <div
                  v-if="facilityData.COUPON && facilityData.COUPON == 1"
                  :class="[$style.facility_content_box,$style.coupon_box]"
                  @click="clickCoupon(coupons[0].COUPON_NO,coupons[0].COUPON_USED_FLAG)"
                >
                  <div :class="$style.img_icon_content_box">
                    <div :class="$style.icon_content_box">
                      <p :class="$style.icon_box">
                        <span :class="[$style.icon,$style.icon_app_coupon]">アプリクーポン</span>
                      </p>
                      <p v-if="!this.$store.state.auth.loggedIn"
                        :class="$style.loggedInTxt"
                      >
                        ログインのうえご確認ください。<br />
                        ご利用にはJAFアプリのインストールが必要です。
                      </p>
                      <p
                        v-if="this.$store.state.auth.loggedIn && coupons[0]"
                        :class="[$style.content,$style.coupon_content]"
                      >{{coupons[0].COUPON_SUMMARY}}</p>
                    </div>
                  </div>
                  <div
                    v-if="this.$store.state.auth.loggedIn && coupons[0] && (!coupons[1] || isMobile())"
                    :class="$style.start_end_time">
                    {{dateString(coupons[0].COUPON_START_DATE)}} ～ {{dateString(coupons[0].COUPON_STOP_DATE)}}
                  </div>
                  <div
                    v-if="this.$store.state.auth.loggedIn && coupons[1] && !showAccordion && !isMobile()"
                    :class="[$style.see_more,$style.see_more_pc]"
                    @click.stop="showCoupons"
                  >
                    <span>もっと見る</span>
                    <span><img src="@img/icon_48_more.png" alt=""/></span>
                  </div>
                </div>

                <!-- sp クーポン2件以上　アコーディオン表示の場合 -->
                <div
                  v-if="isMobile() && this.$store.state.auth.loggedIn"
                  class="accordion_show"
                  :class="[$style.accordion_coupon_list, this.showAccordion ? $style.on : '']"
                >
                  <div
                    v-if="this.$store.state.auth.loggedIn && coupons[1] && !showAccordion && isMobile()"
                    :class="$style.accordion_coupon_list_gradation"
                    @click="showCoupons">
                  </div>
                  <div
                    v-for="(coupon, c_index) in coupons"
                    v-if="c_index != 0"
                    :key="c_index"
                    :class="[$style.facility_content_box,$style.coupon_box,$style.accordion_coupon_box]"
                    @click="clickCoupon(coupon.COUPON_NO,coupon.COUPON_USED_FLAG)"
                  >
                    <div :class="$style.img_icon_content_box">
                      <div :class="$style.icon_content_box">
                        <p :class="$style.icon_box">
                          <span :class="[$style.icon,$style.icon_app_coupon]">アプリクーポン</span>
                        </p>

                        <p
                          :class="[$style.content,$style.coupon_content]"
                        >{{coupon.COUPON_SUMMARY}}</p>
                      </div>
                    </div>
                    <div
                      :class="$style.start_end_time">
                      {{dateString(coupon.COUPON_START_DATE)}} ～ {{dateString(coupon.COUPON_STOP_DATE)}}
                    </div>

                  </div>

                </div>
                <div
                  v-if="this.$store.state.auth.loggedIn && coupons[1] && !showAccordion && isMobile()"
                  :class="$style.see_more"
                  @click="showCoupons"
                >
                  <img src="@img/arrow_simple_32_D_navy.png" alt="">
                  <span>もっと見る</span>
                </div>

                <div
                  v-show="showAccordion"
                  :class="$style.see_more"
                  @click="closeAccordion"
                >
                  <img src="@img/arrow_simple_32_U_navy.png" alt="">
                  <span>閉じる</span>
                </div>

                <!-- 特別優待 -->
                <div v-if="isShowTokubetsuValidityDatePeriodArea"
                   :class="$style.facility_content_box">
                  <div :class="$style.img_icon_content_box">
                    <div :class="$style.icon_content_box">
                      <p :class="$style.icon_box">
                        <span :class="[$style.icon,$style.icon_limited_time]">特別優待</span>
                      </p>
                      <p
                        :class="[$style.content,$style.limited_facility_content]"
                        @click="toTokubetsuUrl"
                        v-html="getNl2brString(facilityData.TOKUBETU_NAIYOU)"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="(facilityData.PREMIAM_FLAG !== '1' || (facilityData.COUPON && facilityData.COUPON === '1') || isShowTokubetsuValidityDatePeriodArea) ||
                        (facilityData.WB_NAIYO1 || facilityData.WB_NAIYO2 || facilityData.WB_NAIYO3 || facilityData.WB_NAIYO4 || facilityData.WB_NAIYO5)">
              <!-- いつでも使える優待title -->
              <div v-if="facilityData.FACILITIES_TYPE == '1'" :class="$style.whenever_facility_box">
                <img src="@img/icon_crown.png" alt="いつでも使える優待アイコン">
                <p :class="$style.facility_label">
                  いつでも使える優待
                </p>
              </div>
               <!-- 今だけ使える優待/yyyy年MM月dd日まで使える優待title -->
              <div v-if="facilityData.FACILITIES_TYPE == '3'" :class="$style.whenever_facility_box">
                <img src="@img/icon_crown.png" alt="今だけ使える優待/yyyy年MM月dd日まで使える優待アイコン">
                <p v-if="facilityData.YUUKOUKIAN_E" :class="$style.facility_label">
                  {{ facilityData.YUUKOUKIAN_E.slice(0,4) + '年' + facilityData.YUUKOUKIAN_E.slice(4,6) + '月' + facilityData.YUUKOUKIAN_E.slice(6,8) + '日'}}まで使える優待
                </p>
                <p v-else :class="$style.facility_label">
                  今だけ使える優待
                </p>
              </div>
            </template>

            <div :class="$style.benefit_content_box">
              <ul>
                <li
                  v-if="(facilityData.WB_NAIYO1 ||
                        facilityData.WB_NAIYO2 ||
                        facilityData.WB_NAIYO3 ||
                        facilityData.WB_NAIYO4 ||
                        facilityData.WB_NAIYO5) &&
                        facilityData.FACILITIES_TYPE !== '5'"
                  :class="$style.no_last_margin">
                  <p v-if="facilityData.WB_NAIYO1">
                    <b>優待①</b>
                    <br />
                    <span v-if="facilityData.WB_NAIYO1">{{
                      facilityData.WB_NAIYO1
                    }}</span>
                    <span v-if="facilityData.WB_HANNI1">{{
                      facilityData.WB_HANNI1
                    }}</span>
                    <span v-if="discount1">{{ discount1 }}</span>
                    <br />
                    <br />
                  </p>
                  <p v-if="facilityData.WB_NAIYO2">
                    <b>優待②</b>
                    <br />
                    <span v-if="facilityData.WB_NAIYO2">{{
                      facilityData.WB_NAIYO2
                    }}</span>
                    <span v-if="facilityData.WB_HANNI2">{{
                      facilityData.WB_HANNI2
                    }}</span>
                    <span v-if="discount2">{{ discount2 }}</span>
                    <br />
                    <br />
                  </p>
                  <p v-if="facilityData.WB_NAIYO3">
                    <b>優待③</b>
                    <br />
                    <span v-if="facilityData.WB_NAIYO3">{{
                      facilityData.WB_NAIYO3
                    }}</span>
                    <span v-if="facilityData.WB_HANNI3">{{
                      facilityData.WB_HANNI3
                    }}</span>
                    <span v-if="discount3">{{ discount3 }}</span>
                    <br />
                    <br />
                  </p>
                  <p v-if="facilityData.WB_NAIYO4">
                    <b>優待④</b>
                    <br />
                    <span v-if="facilityData.WB_NAIYO4">{{
                      facilityData.WB_NAIYO4
                    }}</span>
                    <span v-if="facilityData.WB_HANNI4">{{
                      facilityData.WB_HANNI4
                    }}</span>
                    <span v-if="discount4">{{ discount4 }}</span>
                    <br />
                    <br />
                  </p>
                  <p v-if="facilityData.WB_NAIYO5">
                    <b>優待⑤</b>
                    <br />
                    <span v-if="facilityData.WB_NAIYO5">{{
                      facilityData.WB_NAIYO5
                      }}</span>
                      <span v-if="facilityData.WB_HANNI5">{{
                      facilityData.WB_HANNI5
                    }}</span>
                    <span v-if="discount5">{{ discount5 }}</span>
                    <br />
                    <br />
                  </p>
                </li>
                <li v-if="facilityData.KAINSYOSO && facilityData.FACILITIES_TYPE !== '5'" :class="$style.useMethod">
                  <div>
                    <p :class="$style.bold">会員優待利用方法</p>
                    <p>{{ facilityData.KAINSYOSO }}</p>
                  </div>
                </li>
                <li v-if="facilityData.WB_TAISYO && facilityData.FACILITIES_TYPE !== '5'" :class="$style.useGroup">
                  <div>
                    <p :class="$style.bold">優待対象</p>
                    <p>{{ facilityData.WB_TAISYO }}</p>
                  </div>
                  <br />
                </li>
                <div v-if="facilityData.WB_CYUUI">
                  <li>
                    <p :class="[$style.bold, $style.red]">ご注意</p>
                    <p :class="$style.red" v-html="getCyuui"></p>
                  </li>
                </div>
                <div v-if="facilityData.WEB_FLAG === '1' && !isExcludeWebFacilities">
                  <li>
                    <p :class="[$style.bold, $style.red]"
                      >※JAF会員以外はご利用いただけません</p
                    >
                  </li>
                </div>
              </ul>
            </div>

            <!-- 施設を利用するボタン -->
            <div v-if="!isLinksMode" :class="$style.useArea">
              <div :class="$style.top_online_btn">
                <!-- USED_TYPEが１の場合 -->
                <a v-if="showBarcodeButton() === 'code'"
                  :class="barcodeButtonCSS"
                  @click="openSelectBarcode">
                  <div :class="barcodeButtonCSS2">
                    <div v-if="txtBarcodeBtn !== ''">
                      {{ txtBarcodeBtn }}
                    </div>
                    <div v-if="txtBarcodeSubBtn !== ''">
                      {{ txtBarcodeSubBtn }}
                    </div>
                  </div>
                </a>

                <!-- USED_TYPEが0で、ウェブフラグが1の場合 -->
                <a
                  v-else-if="'1' === facilityData.WEB_FLAG"
                  :class="$style.button"
                  @click="toOnlineUrl"
                >
                  オンライン優待サイトを表示する
                </a>

                <!-- USED_TYPEが0で、ウェブフラグが0で、クーポン対象施設フラグが1の場合 -->
                <a v-else-if="'1' === facilityData.COUPON_TARGET_FLAG"
                  :class="[$style.button, $style.out_button]"
                  >クーポンをご利用下さい</a
                >

                <!-- USED_TYPEが0で、ウェブフラグが0で、クーポン対象施設フラグが0の場合 -->
                <a v-else-if="isMobile()"
                  :class="$style.button" @click="toMemberCard"
                  >ＪＡＦアプリ（会員証）を開く</a
                >
                <p
                  v-if="showBarcodeButton() === 'card' &&
                   '1' !== facilityData.WEB_FLAG &&
                   '1' !== facilityData.COUPON_TARGET_FLAG &&
                   isMobile() "
                  :class="$style.red"
                  >※ＪＡＦアプリのインストールが必要です。</p
                >
              </div>
            </div>

            <!-- 基本情報 -->
            <div :id="$style.facility" :class="facilityInfoBoxCSS">
              <div :class="$style.info_title_box">
                <p :class="$style.title">基本情報</p>
                <div v-if="facilityData.CYUSYAJO" :class="$style.parking_box">
                  <img src="@img/icon_parking.png" alt="駐車場アイコン">
                  <p v-html="getNl2brString(facilityData.CYUSYAJO)"></p>
                </div>
              </div>

              <ul :class="$style.infoArea">
                <li :class="$style.oneSet">
                  <div :class="$style.inner">
                    <ol :class="$style.buttonNone">
                      <li v-if="'1' != facilityData.WEB_FLAG">
                        <p :class="$style.bold">住所</p>
                        <p>
                          <a :class="$style.tlink" @click="toMap">
                            〒{{ facilityData.POST_CD }}
                            <br />
                            {{ facilityData.SYOZAITI }}
                          </a>
                        </p>
                        <div v-if="clientType !== 2" :class="$style.rightPut">
                          <a
                            :class="[$style.button, $style.navi_button]"
                            @click="openApplink"
                            >道案内・カーナビ連携</a
                          >
                        </div>
                      </li>
                      <li v-if="facilityData.TEL">
                        <p :class="$style.bold">TEL</p>
                        <p>
                          <Tel :tel="facilityData.TEL" />
                        </p>
                      </li>
                      <li v-if="facilityData.PC_URL && ((facilityData.WEB_FLAG === '0' && !isLinksMode) || facilityData.WEB_FLAG !== '1')">
                        <p :class="$style.bold">URL</p>
                        <p>
                          <a :class="$style.tlink" @click="toPCUrl">{{
                            facilityData.PC_URL
                          }}</a>
                        </p>
                      </li>
                      <li v-if="facilityData.MEISYO_YOMI">
                        <div>
                          <p :class="$style.bold">名称ヨミ</p>
                          <p>{{ facilityData.MEISYO_YOMI }}</p>
                        </div>
                      </li>
                      <li v-if="facilityData.BARI_MEMO">
                        <div>
                          <p :class="$style.bold">バリアフリーメモ</p>
                          <p v-html="getNl2brString(facilityData.BARI_MEMO)"></p>
                        </div>
                      </li>
                      <li v-if="facilityData.KAISETU">
                        <div>
                          <p :class="$style.bold">解説</p>
                          <p v-html="getKaisetsu"></p>
                        </div>
                      </li>
                      <li>
                        <div>
                          <p :class="$style.bold">備考</p>
                          <p v-html="getBikou"></p>
                          <p :class="$style.confirm_link" @click="goGuidance">ご利用前の確認事項はこちら</p>
                        </div>
                      </li>
                    </ol>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form id="ssnIdPostForm" name="ssnIdForm" action="" method="POST" target="_blank"></form>
    <form id="ssnIdPremPostForm" name="ssnIdFormPrem" action="" method="POST"></form>

    <Footer />
    <ApplinkPopup
      :show="showApplink"
      :lat="facilityData.LAT"
      :lon="facilityData.LON"
      :name="facilityData.MEISYO"
      @cancel="cancelApplink"
    ></ApplinkPopup>
    <SelectBarcodePopup
      :show="showSelectBarcode"
      :button_title1="barcodeData[0].BUTTON_TITLE"
      :button_title2="barcodeData[1].BUTTON_TITLE"
      :button_title3="barcodeData[2].BUTTON_TITLE"
      :button_title4="barcodeData[3].BUTTON_TITLE"
      :button_title5="barcodeData[4].BUTTON_TITLE"
      :button_title6="barcodeData[5].BUTTON_TITLE"
      :button_title7="barcodeData[6].BUTTON_TITLE"
      :button_hidden1="compare_date(barcodeData[0].PUBLICATION_START_DATE, barcodeData[0].PUBLICATION_END_DATE) === '1'"
      :button_hidden2="compare_date(barcodeData[1].PUBLICATION_START_DATE, barcodeData[1].PUBLICATION_END_DATE) === '1'"
      :button_hidden3="compare_date(barcodeData[2].PUBLICATION_START_DATE, barcodeData[2].PUBLICATION_END_DATE) === '1'"
      :button_hidden4="compare_date(barcodeData[3].PUBLICATION_START_DATE, barcodeData[3].PUBLICATION_END_DATE) === '1'"
      :button_hidden5="compare_date(barcodeData[4].PUBLICATION_START_DATE, barcodeData[4].PUBLICATION_END_DATE) === '1'"
      :button_hidden6="compare_date(barcodeData[5].PUBLICATION_START_DATE, barcodeData[5].PUBLICATION_END_DATE) === '1'"
      :button_hidden7="compare_date(barcodeData[6].PUBLICATION_START_DATE, barcodeData[6].PUBLICATION_END_DATE) === '1'"
      @open="openBarcode"
      @cancel="cancelSelectBarcode"
    ></SelectBarcodePopup>
    <BarcodePopup
      :show="showBarcode"
      :barcode="barcodePopupData"
      @cancel="cancelBarcode"
    ></BarcodePopup>
    <FacilityPopup
      :show="showFacilityPop"
      @ok="okPop"
    ></FacilityPopup>
  </Layout>
</template>

<style lang="scss" module>
// @import '@design';
@import '@assets/css/common.scss';
@import '@assets/css/SU-08.scss';
.facilityDetail {
  width: 100%;
}
.noCouponText {
  text-align: center;
  margin-top: 40px;
  display: block;
  color: green;
}

#maintenance_banner {
  max-width: 1000px;
  width: 100%;
  margin: auto;
  padding: 10px 0px;
}

#maintenance_banner a{
  display: inline-block;
}

#maintenance_banner img{
  width: 100%;
}

@media screen and (min-width: 768px) {
  .facilityDetail {
    min-height: calc(100vh - 260px);
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  #jaf_container{
    // height: 94%;
    height: calc(100% - 15vw);
  }
}
// ipad
@media screen and (min-width: 768px) and (max-width: 1025px) {
  #jaf_container{
    width: 100%;
    overflow-x: hidden;
  }
}
</style>
